import {AnalysisService} from '../services/analysis.service';
import {RecommendationService} from '../services/recommendation.service';
import {Component, OnInit} from '@angular/core';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css']
})
export class StatsComponent implements OnInit {

  constructor(
    private analysisService: AnalysisService,
    private recommendationService: RecommendationService
  ) {}

  ngOnInit(): void {
  }

  getIsHK(): boolean {
    return isHK;
  }

  getUslonecznienie() {return this.analysisService.getUslonecznienie(); }
  getNaslonecznienie() {return this.analysisService.getI_g(); }
  getRoofArea() {
    return this.analysisService.getRoofArea();
  }

  getSavings20() {
    let sv = this.recommendationService.get20ySavings();
    sv = Math.ceil(sv / 10) * 10;
    return sv;
  }

  getEnergyAmount() {
    return this.getRoofArea() * this.getNaslonecznienie() ;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/stats/stats.component.ts